import { APPLICATION_STATUS, STATUS } from 'constants/constants';
import { TFunction } from 'i18next';

function uniqueFilter(value: number, index: number, self: number[]): boolean {
    return self.indexOf(value) === index;
}

export function getApplicationStatuses(statuses: number[], t: TFunction): string[] {
    let consolidatedStatus: string[] = [];

    if (statuses) {
        const uniqueStatuses: number[] = statuses.filter(uniqueFilter);

        if (uniqueStatuses.length === 1) {
            consolidatedStatus.push(APPLICATION_STATUS(t)?.[statuses[0]]);
        } else {
            consolidatedStatus = statuses.map(s => APPLICATION_STATUS(t)?.[s]);
        }
    }

    return consolidatedStatus;
}

export function canContinueConsultation(statuses: number[]): boolean {
    // DWPT-2919 Hot Fix for production env
    // to be fixed per new clients' requirements
    return true;

    if (statuses) {
        const uniqueStatuses: number[] = statuses.filter(uniqueFilter);

        return !(uniqueStatuses.length === 1 && (
            uniqueStatuses.includes(STATUS.submitted)
            || uniqueStatuses.includes(STATUS.completed)
            || uniqueStatuses.includes(STATUS.canceled)
            || uniqueStatuses.includes(STATUS.expired)));
    }

    return true;
}
